import { createSlice } from "@reduxjs/toolkit";
import store from "../store";

const modalSlice = createSlice({
  name: "modals",
  initialState: [],
  reducers: {
    addModal: (state, action) => {
      const { message, type, onConfirm } = action.payload;
      const id = Date.now();
      state.push({ id, message, type, onConfirm });
    },
    closeModal: (state, action) => {
      return state.filter((data) => data.id !== action.payload);
    },
    showLoading: (state, action) => {
      const id = Date.now();
      state.push({ id, type:"loader" });
    },
    hideLoading: (state, action) => {
      return state.filter((data) => data.type !== "loader");
    },
    closeAllModals: (state, action) => {
      return [];
    }
  },
});

export const { addModal, closeModal, showLoading, hideLoading, closeAllModals } = modalSlice.actions;
export default modalSlice.reducer;
